import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { RegisterComponent } from './register/register.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SignatureComponent } from './signature/signature.component';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '../components/components.module';
import { RouterModule } from '@angular/router';
import { CpfCnpjPipeModule } from '../shared/pipes/CpfCnpjModule';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { SubscriberListComponent } from './signature/components/subscriber-list/subscriber-list.component';
import { SignerHistoryComponent } from './signature/components/signer-history/signer-history.component';
import { SignUpModalComponent } from './signature/components/sign-up-modal/sign-up-modal.component';
import { NgxMaskModule } from 'ngx-mask';
import { SignersButtonComponent } from './signature/components/signers-button/signers-button.component';
import { SignerMobileFormComponent } from './signature/components/signer-mobile-form/signer-mobile-form.component';
import { SignatureFooterComponent } from './signature/components/signature-footer/signature-footer.component';
import { SignerSuccessComponent } from './signer-success/signer-success.component';
import { SignerErrorComponent } from './signer-error/signer-error.component';
import { SafePipe } from '../shared/pipes/safe-pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';


const components = [
  HomeComponent,
  RegisterComponent,
  SignatureComponent,
  SubscriberListComponent,
  SignerHistoryComponent,
  SignUpModalComponent,
  SignersButtonComponent,
  SignerMobileFormComponent,
  SignatureFooterComponent,
  SignerSuccessComponent,
  SignerErrorComponent,
  SafePipe
]

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ComponentsModule,
    RouterModule,
    CpfCnpjPipeModule,
    NgxDocViewerModule,
    NgbModule,
    NgxMaskModule.forRoot(),
    ToastrModule.forRoot()
  ],  
  declarations: [
    components
  ],
  exports: [components]
})
export class PagesModule { }
